<template>
  <div>
    <!-- <Categorylist></Categorylist> -->
    <div class="commodityInfobox">
      <img
        class="imgbox1"
        :src="productInfo.productMainImage"
        alt
        mode="widthFix"
      />
      <div class="commoditytitlebox">{{ productInfo.productName }}</div>
      <div class="commoditynamebox">{{ productInfo.productBrief }}</div>
      <div class="commoditytagbox">
        <div class="commoditytag" v-if="productInfo.isQuantity == 1">
          限量款
        </div>
      </div>

      <div class="pricebox">
        <div class="pricelablebox">价格</div>
        <div class="pricenumbox" v-if="productInfo.linePrice">
          <span style="text-decoration: line-through; margin-right: 10px"
            >￥{{ productInfo.linePrice }}</span
          >
          <span style="color: #d62938"
            >￥{{ productSkuInfo.skuUnitPrice || productInfo.unitPrice }}</span
          >
          <span v-if="productInfo.discountRate" style="color: #d62938"
            >（{{ productInfo.discountRate * 10 }}折）</span
          >
          <span v-if="productInfo.discountAmount" style="color: #d62938"
            >（优惠{{ productInfo.discountAmount }}元）</span
          >
        </div>
        <div class="pricenumbox" v-else>
          ￥{{ productSkuInfo.skuUnitPrice || productInfo.unitPrice }}
        </div>

        <div
          class="pricenumbox"
          style="margin-left: 10px; color: #ff0000; font-weight: 400"
          v-if="productSkuInfo.id && productSkuInfo.skuTotalUnit <= 0"
        >
          已售罄
        </div>
      </div>
      <div class="skubox">
        <div
          class="marginbuttom10"
          v-for="item in productInfo.sku"
          :key="item.id"
        >
          <div class="pricelablebox">{{ item.name }}</div>
          <div class="inlinerightbox">
            <el-select
              size="small"
              v-model="item.checkedId"
              placeholder="请选择"
              @change="changeSkuSelect"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="ctem in item.val"
                :key="ctem.id"
                :disabled="ctem.skuTotalUnit == 0"
                :label="ctem.skuValue"
                :value="ctem.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div style="margin-top: 12px">
        <div v-for="item in productInfo.attrValue" :key="item.id">
          <div class="attrValuebox">
            <div
              class="attrValuetitle"
              @click="item.showContent = !item.showContent"
            >
              <div>{{ item.attrName }}</div>
              <div class="pad24">
                <span v-if="!item.showContent">+</span>
                <span v-else-if="item.showContent">-</span>
              </div>
            </div>
            <div class="font24" v-if="item.showContent">
              <p v-html="item.attrVal"></p>
            </div>
          </div>
        </div>
      </div>

      <div class="margintop70">
        <van-divider>图文详情</van-divider>
        <div v-if="productInfo.productDesc">
          <p v-html="productInfo.productDesc"></p>
        </div>
        <div v-if="productInfo.productContent">
          <img
            v-for="(item, index) in productInfo.productContent.split(',')"
            :key="index"
            class="contentimg"
            :src="item"
            alt
            mode="widthFix"
          />
        </div>
      </div>

      <div class="margintop70">
        <div class="recommendtitle">相关商品</div>
        <div>
          <!-- <van-swipe :autoplay="3000" :loop="false" :width="windowWidth / 3"> -->
          <van-swipe :autoplay="3000" :loop="false" width="165">
            <van-swipe-item v-for="item in recommendList" :key="item.id">
              <div>
                <img
                  class="imgbox2"
                  :src="item.productMainImage"
                  @click="changgeProduct(item.id)"
                  alt
                  mode="widthFix"
                />
                <div class="recommendname">{{ item.productName }}</div>
                <div class="recommendprice" v-if="item.linePrice">
                  <span
                    style="text-decoration: line-through; margin-right: 10px"
                    >￥{{ item.linePrice }}</span
                  >
                  <span style="color: #d62938">￥{{ item.unitPrice }}</span>
                  <span v-if="item.discountRate" style="color: #d62938"
                    >（{{ item.discountRate * 10 }}折）</span
                  >
                  <span v-if="item.discountAmount" style="color: #d62938"
                    >（优惠{{ item.discountAmount }}元）</span
                  >
                </div>
                <div class="recommendprice" v-else>￥{{ item.unitPrice }}</div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
    <div class="footbox">
      <div class="zhanweifoot"></div>
      <div class="footcontentbox">
        <div class="xinyuanbox">
          <img
            v-if="productInfo.iscollect == 0"
            class="xinyuanicon"
            @click="addCollect"
            src="../../assets/imgs/xinyuandan-weixuanzhong@3x.png"
            alt
          />
          <img
            v-if="productInfo.iscollect == 1"
            @click="delCollect"
            class="xinyuanicon"
            src="../../assets/imgs/xinyuandan-xuanzhong@3x.png"
            alt
          />
          <div>心愿单</div>
        </div>
        <div>
          <div class="jioncarbtn" @click="addCart">加入购物车</div>
          <div class="buybtn" @click="openPup">立即购买</div>
        </div>
      </div>
    </div>
    <div class="zhaweifoot"></div>
    <van-popup
      v-model="showPup"
      closeable
      position="bottom"
      :style="{ height: '30%' }"
    >
      <div>
        <div class="pupmainbox">
          <div class="flexbox">
            <div class="numlable">数量</div>
            <van-stepper
              v-model="stepValue"
              disable-input
              min="1"
              :max="productSkuInfo.skuTotalUnit"
            />
          </div>
        </div>

        <div class="pupbtn" @click="toBuyforCart">确定</div>
      </div>
    </van-popup>
    <Logindia ref="logindia"></Logindia>
    <div class="zrl">
      <div class="zrl pcpage" ref="pcpage">
        <div class="pcproductdesc">
          <div v-if="productInfo.productDesc" style="padding-top: 30px;">
            <p v-html="productInfo.productDesc"></p>
          </div>
          <div v-if="productInfo.productContent">
            <img
              v-for="(item, index) in productInfo.productContent.split(',')"
              :key="index"
              class="pccontentimg"
              :src="item"
              alt
              mode="widthFix"
            />
          </div>
        </div>
        <div class="pccommodityInfobox" ref="pccommodityInfobox">
          <img
            class="pcimgbox1"
            :src="productInfo.productMainImage"
            alt
            mode="widthFix"
          />
          <div class="pccommoditytitlebox">{{ productInfo.productName }}</div>
          <div class="pccommoditynamebox">{{ productInfo.productBrief }}</div>
          <div class="pccommoditytagbox">
            <div class="pccommoditytag" v-if="productInfo.isQuantity == 1">
              限量款
            </div>
          </div>

          <div class="pricebox">
            <div class="pricelablebox">价格</div>
            <div class="pricenumbox" v-if="productInfo.linePrice">
              <span style="text-decoration: line-through; margin-right: 10px"
            >￥{{ productInfo.linePrice }}</span
          >
          <span style="color: #d62938"
            >￥{{ productSkuInfo.skuUnitPrice || productInfo.unitPrice }}</span
          >
          <span v-if="productInfo.discountRate" style="color: #d62938"
            >（{{ productInfo.discountRate * 10 }}折）</span
          >
          <span v-if="productInfo.discountAmount" style="color: #d62938"
            >（优惠{{ productInfo.discountAmount }}元）</span
          >
            </div>
            <div class="pricenumbox" v-else>
              ￥{{ productSkuInfo.skuUnitPrice || productInfo.unitPrice }}
            </div>
            <div
              class="pricenumbox"
              style="margin-left: 10px; color: #ff0000; font-weight: 400"
              v-if="productSkuInfo.id && productSkuInfo.skuTotalUnit <= 0"
            >
              已售罄
            </div>
          </div>
          <div class="skubox">
            <div
              class="marginbuttom10"
              v-for="item in productInfo.sku"
              :key="item.id"
            >
              <div class="pricelablebox">{{ item.name }}</div>
              <div class="inlinerightbox">
                <el-select
                  size="small"
                  v-model="item.checkedId"
                  placeholder="请选择"
                  @change="changeSkuSelect"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="ctem in item.val"
                    :key="ctem.id"
                    :disabled="ctem.skuTotalUnit == 0"
                    :label="ctem.skuValue"
                    :value="ctem.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="marginbuttom10">
              <div class="pricelablebox">数量</div>
              <div class="inlinerightbox">
                <van-stepper
                  v-model="stepValue"
                  disable-input
                  min="1"
                  :max="productSkuInfo.skuTotalUnit"
                />
              </div>
            </div>
          </div>
          <div class="margintop12">
            <div v-for="item in productInfo.attrValue" :key="item.id">
              <div class="attrValuebox">
                <div
                  class="attrValuetitle"
                  @click="item.showContent = !item.showContent"
                >
                  <div>{{ item.attrName }}</div>
                  <div class="pad24">
                    <span v-if="!item.showContent">+</span>
                    <span v-else-if="item.showContent">-</span>
                  </div>
                </div>
                <div class="font24" v-if="item.showContent">
                  <p v-html="item.attrVal"></p>
                </div>
              </div>
            </div>
          </div>

          <div class="pcfootbox">
            <!-- <div class="zhanweifoot"></div> -->
            <div class="footcontentbox">
              <div class="xinyuanbox">
                <img
                  v-if="productInfo.iscollect == 0"
                  class="xinyuanicon"
                  @click="addCollect"
                  src="../../assets/imgs/xinyuandan-weixuanzhong@3x.png"
                  alt
                />
                <img
                  v-if="productInfo.iscollect == 1"
                  @click="delCollect"
                  class="xinyuanicon"
                  src="../../assets/imgs/xinyuandan-xuanzhong@3x.png"
                  alt
                />
                <!-- <div>心愿单</div> -->
              </div>
              <div>
                <div class="jioncarbtn" @click="addCart">加入购物车</div>
                <div class="buybtn" @click="buyForPc">立即购买</div>
              </div>
            </div>
          </div>
          <!-- <div class="pczhanweione"></div> -->
        </div>
      </div>
      <div class="zrl">
        <div>
          <div class="pcrecommendtitle">相关商品</div>
          <div class="pc1345">
            <!-- <van-swipe :autoplay="3000" :loop="false" :width="330">
              <van-swipe-item v-for="item in recommendList" :key="item.id">
                <div>
                  <img
                    class="pcimgbox2"
                    :src="item.productMainImage"
                    @click="changgeProduct(item.id)"
                    alt
                    mode="widthFix"
                  />
                  <div class="pccommoditytitlebox" style="margin-left: 0px">
                    {{ item.productName }}
                  </div>
                  <div class="pccommoditytitlebox" style="margin-left: 0px">
                    ￥{{ item.unitPrice }}
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe> -->

            <!-- <el-carousel :interval="4000" type="card" height="500px" >
              <el-carousel-item v-for="item in recommendList" :key="item.id">
                <div style="height: 300px;text-align: center;">
                  <img
                    class="pcimgbox2"
                    :src="item.productMainImage"
                    @click="changgeProduct(item.id)"
                    alt
                    mode="widthFix"
                  />
                  <div class="pccommoditytitlebox" style="margin-left: 0px">
                    {{ item.productName }}
                  </div>
                  <div class="pccommoditytitlebox" style="margin-left: 0px">
                    ￥{{ item.unitPrice }}
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel> -->

            <!-- <div style="display: flex; flex-wrap: nowrap">
              <div
                style="
                  text-align: center;
                  dispay: inline-block;
                  vertical-align: top;
                  margin-right: 10px;
                  width: 300px;
                "
                v-for="item in recommendList"
                :key="item.id"
              >
                <img
                  class="pcimgbox2"
                  :src="item.productMainImage"
                  @click="changgeProduct(item.id)"
                  alt
                  mode="widthFix"
                />
                <div class="pccommoditytitlebox" style="margin-left: 0px">
                  {{ item.productName }}
                </div>
                <div class="pccommoditytitlebox" style="margin-left: 0px">
                  ￥{{ item.unitPrice }}
                </div>
              </div>
            </div> -->

            <swiper
              :options="swiperOption"
              ref="mySwiper"
              v-if="recommendList.length > 0"
            >
              <swiper-slide
                v-for="item in recommendList"
                :key="item.id"
                style="width: 300px"
              >
                <div style="text-align: center">
                  <img
                    class="pcimgbox2"
                    :src="item.productMainImage"
                    @click="changgeProduct(item.id)"
                    alt
                    mode="widthFix"
                  />
                  <div class="pccommoditytitlebox" style="margin-left: 0px">
                    {{ item.productName }}
                  </div>
                  <div class="pccommoditytitlebox" v-if="item.linePrice" style="margin-left: 0px">
                    <span
                    style="text-decoration: line-through; margin-right: 10px"
                    >￥{{ item.linePrice }}</span
                  >
                  <span style="color: #d62938">￥{{ item.unitPrice }}</span>
                  <span v-if="item.discountRate" style="color: #d62938"
                    >（{{ item.discountRate * 10 }}折）</span
                  >
                  <span v-if="item.discountAmount" style="color: #d62938"
                    >（优惠{{ item.discountAmount }}元）</span
                  >
                  </div>
                  <div class="pccommoditytitlebox" v-else style="margin-left: 0px">
                    ￥{{ item.unitPrice }}
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  productInfo_api,
  productSkuPrice_api,
  addCollect_api,
  delCollect_api,
  addCart_api,
  recommendList_api,
} from "../../apis/product";
import { buyInfoOne_api } from "../../apis/order";
import Categorylist from "../../components/Categorylist.vue";
import Logindia from "../../components/Logindia.vue";
import local from "@/utils/local";
import session from "@/utils/session";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: { Categorylist, Logindia, swiper, swiperSlide },
  data() {
    return {
      commodityId: "",
      value: "",

      productInfo: "",
      productSkuIds: "",
      productSkuInfo: "",
      stepValue: 1,
      showPup: false,
      recommendList: [],
      commodityIdList: [],
      windowWidth: "",
      swiperOption: {
        loop: false,
        notNextTick: true, // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        slidesPerView: "auto", //数量
        spaceBetween: 30, //间距
        slidesPerGroup: 1, //分几组
        direction: "horizontal", //设置水平还是垂直vertical
        // grabCursor: true, //光标样式
        // setWrapperSize: true,
        // autoHeight: true,
        // centeredSlides: true,
        // paginationClickable: true,
        // keyboard: true, //键盘控制
        // mousewheelControl: true, //鼠标轮控制
        autoplay: {
          delay: 3000, //自动切换的时间间隔，单位ms
          stopOnLastSlide: false, //当切换到最后一个slide时停止自动切换
          disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay
          reverseDirection: true, //开启反向自动轮播
          // waitForTransition: true, //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时
        },
      },
    };
  },
  created() {
    this.commodityId = this.$route.query.commodityId;
    // this.commodityIdList.push(this.commodityId)
    // console.log("IdList",this.commodityIdList)
    this.getProductInfo();
    this.windowWidth = window.innerWidth;
  },
  beforeRouteLeave(to, from, next) {
    if (this.commodityIdList.length > 0) {
      let id = this.commodityIdList.pop();
      console.log("IdList", this.commodityIdList);
      this.commodityId = id;
      this.getProductInfo();
      window.scrollTo(0, 0);
    } else {
      next();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.swiper = this.$refs.swiperRef.$swiper; // 确保Swiper实例已正确初始化
    });
  },
  // mounted() {
  //   window.addEventListener("scroll", this.handleScroll);
  // },
  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.handleScroll);
  // },
  methods: {
    async getProductInfo() {
      let { code, data } = await productInfo_api({
        id: this.commodityId,
      });
      if (code == 0) {
        this.productInfo = data;
        //网络慢的极端情况下，使用到上一个产品的多规则信息，所以需要清空
        this.productSkuInfo = "";
        // if (this.productInfo.sku && this.productInfo.sku.length > 0) {
        //   this.productInfo.sku.forEach((item) => {
        //     this.$set(item, "checkedId", item.val[0].id);
        //   });
        //   this.getProductSkuPrice();
        // }

        if (this.productInfo.attrValue) {
          this.productInfo.attrValue.forEach((item) => {
            this.$set(item, "showContent", false);
          });
        }
        if (this.productInfo.isSkuEnabled == 1) {
          this.productInfo.sku.forEach((item) => {
            this.$set(item, "checkedId", item.val[0].id);
          });
          this.getProductSkuPrice();
        }
        // this.getProductSkuPrice();
        this.getRecommendList();
      }
    },
    async getProductSkuPrice() {
      let idsArr = [];
      this.productInfo.sku.forEach((item) => {
        idsArr.push(item.checkedId);
      });
      this.productSkuIds = idsArr.join(",");
      let { code, data } = await productSkuPrice_api({
        ids: this.productSkuIds,
      });
      if (code == 0) {
        this.productSkuInfo = data;
      }
    },
    changeSkuSelect() {
      this.getProductSkuPrice();
    },
    async addCollect() {
      if (local.get("tk") || session.get("tk")) {
        let { code, data } = await addCollect_api({
          productId: this.commodityId,
        });
        if (code == 0) {
          this.getProductInfo();
        }
      } else {
        this.$dialog.alert({
          message: "请先登录！",
        });
      }
    },
    async delCollect() {
      if (local.get("tk") || session.get("tk")) {
        let { code, data } = await delCollect_api({
          productId: this.commodityId,
        });
        if (code == 0) {
          this.getProductInfo();
        }
      } else {
        this.$dialog.alert({
          message: "请先登录！",
        });
      }
    },
    async addCart() {
      if (local.get("tk") || session.get("tk")) {
        if (
          (this.productInfo.isSkuEnabled == 1 &&
            this.productSkuInfo.skuTotalUnit > 0) ||
          (this.productInfo.isSkuEnabled == 0 && this.productInfo.totalunit > 0)
        ) {
          let idsArr = [];
          if (this.productInfo.isSkuEnabled == 1) {
            this.productInfo.sku.forEach((item) => {
              idsArr.push(item.checkedId);
            });
          }
          this.productSkuIds = idsArr.join(",");

          let { code, data, message } = await addCart_api({
            productId: this.commodityId,
            skuids: this.productSkuIds,
            num: 1,
          });
          if (code == 0) {
            this.$dialog.alert({
              message: "成功加入购物车",
            });
          } else {
            this.$toast(message);
          }
        } else {
          this.$toast("暂无库存");
        }
      } else {
        this.$dialog.alert({
          message: "请先登录！",
        });
      }
    },
    openLoginDia() {
      this.$refs.logindia.open("login");
    },
    openPup() {
      if (local.get("tk") || session.get("tk")) {
        if (
          (this.productInfo.isSkuEnabled == 1 &&
            this.productSkuInfo.skuTotalUnit > 0) ||
          (this.productInfo.isSkuEnabled == 0 && this.productInfo.totalunit > 0)
        ) {
          this.showPup = true;
        } else {
          this.$toast("暂无库存");
        }
      } else {
        this.$dialog.alert({
          message: "请先登录！",
        });
      }
    },
    toBuyforCart() {
      let idsArr = [];
      if (this.productInfo.isSkuEnabled == 1) {
        this.productInfo.sku.forEach((item) => {
          idsArr.push(item.checkedId);
        });
      }
      this.productSkuIds = idsArr.join(",");

      this.getBuyInfoOne();

      // this.$router.push(
      //   {
      //     path: "/buyfromcart",
      //     query: {
      //       type: "detail",
      //       id: this.commodityId,
      //       num: this.stepValue,
      //       skuids: this.productSkuIds,
      //     },
      //   },
      //   () => {}
      // );
    },
    async getBuyInfoOne() {
      let { code, data } = await buyInfoOne_api({
        id: this.commodityId,
        num: this.stepValue,
        skuids: this.productSkuIds,
      });
      if (code == 0) {
        this.$router.push(
          {
            path: "/buyfromcart",
            query: {
              type: "detail",
              id: this.commodityId,
              num: this.stepValue,
              skuids: this.productSkuIds,
            },
          },
          () => {}
        );
      }
    },
    async getRecommendList() {
      let { code, data } = await recommendList_api({
        productId: this.commodityId,
      });
      if (code == 0) {
        this.recommendList = data;
      }
    },
    changgeProduct(id) {
      this.commodityIdList.push(this.commodityId);
      this.commodityId = id;
      this.getProductInfo();
      window.scrollTo(0, 0);

      console.log("IdList", this.commodityIdList);

      // this.$router.push(
      //   {
      //     path: "/commoditydetails",
      //     query: {
      //       commodityId: id
      //     }
      //   },
      //   () => {}
      // );

      // this.$router.push(
      //   {
      //     name: "Commoditydetails",
      //     query: {
      //       commodityId: id
      //     }
      //   },
      //   () => {}
      // );
    },
    // handleScroll() {
    //   let pccommodityInfoboxHeight = this.$refs.pccommodityInfobox.offsetHeight; // 获取元素的高度
    //   let pcpageHeight = this.$refs.pcpage.offsetHeight; // 获取元素的高度
    //   let windowHeight = window.innerHeight; // 获取窗口的高度
    //   console.log("pccommodityInfoboxHeight", pccommodityInfoboxHeight);
    //   console.log("pcpageHeight", pcpageHeight);
    //   console.log("windowHeight", windowHeight);
    //   let scrollTop = window.scrollY; // 获取滚动条的垂直滚动距离
    //   if (pcpageHeight > windowHeight + scrollTop) {
    //     if (pccommodityInfoboxHeight < windowHeight - 88) {
    //       this.$refs.pccommodityInfobox.style.position = "fixed";
    //       this.$refs.pccommodityInfobox.style.top = 88 + "px";
    //     } else {
    //       if (scrollTop > pccommodityInfoboxHeight - windowHeight) {
    //         this.$refs.pccommodityInfobox.style.position = "fixed";
    //         this.$refs.pccommodityInfobox.style.top = 88 + "px";
    //       }
    //     }
    //   } else {
    //     this.$refs.pccommodityInfobox.style.position = "static";
    //   }
    // },

    buyForPc() {
      if (local.get("tk") || session.get("tk")) {
        if (
          (this.productInfo.isSkuEnabled == 1 &&
            this.productSkuInfo.skuTotalUnit > 0) ||
          (this.productInfo.isSkuEnabled == 0 && this.productInfo.totalunit > 0)
        ) {
          this.toBuyforCart();
        } else {
          this.$toast("暂无库存");
        }
      } else {
        this.$dialog.alert({
          message: "请先登录！",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.zhanwei {
  width: 100%;
  height: 50px;
}

.logobox {
  width: 130px;
  height: 48px;
  margin: 0 auto;
}

.logoimg {
  width: 130px;
  height: 48px;
}

.categorybox {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #dddddd;
  margin-top: 30px;
}

.categoryitembox {
  width: 148px;
  height: 60px;
  // border-top: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 60px;
  text-align: center;
}

.categoryitembox:nth-child(5n) {
  border-right: none;
}

.commodityInfobox {
  margin: 0 auto;
  margin-top: 50px;
  width: 690px;
}

.imgbox1 {
  width: 690px;
}

.commoditytitlebox {
  margin-top: 20px;
  font-size: 30px;
  font-family: PingFang;
  font-weight: bold;
  //color: #666666;
  color: #555555;
}

.commoditynamebox {
  margin-top: 20px;
  font-size: 30px;
  font-family: PingFang;
  font-weight: 500;
  color: #333333;
}

.commoditytagbox {
  margin-top: 20px;
}

.commoditytag {
  display: inline-block;
  vertical-align: top;
  margin: 0px 10px 10px 0px;
  width: fit-content;
  padding: 0 10px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 500;
  color: #7c7d7d;
  border: 1px solid #bbbbbb;
}

.pricebox {
  width: 676px;
  padding-left: 14px;
  line-height: 60px;
  height: 60px;

  border: 2px solid #e3e3e3;
}

.attrValuebox {
  // width: 676px;
  // padding-left: 14px;
  width: 690px;
  border-top: 2px solid #333;
  // border-bottom: 2px solid #222;
  padding: 12px 0px;
}

.attrValuetitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  padding: 0px 14px;
}

.pad24 {
  padding: 12px;
}

.font24 {
  font-size: 24px;
  padding: 0 14px;
}

.pricelablebox {
  display: inline-block;
  vertical-align: top;
  width: 205px;
  font-size: 28px;
  font-family: PingFang;
  font-weight: 500;
  color: #333333;
}

.pricenumbox {
  display: inline-block;
  vertical-align: top;
  font-size: 28px;
  font-family: Heiti SC;
  font-weight: 500;
  //color: #000000;
  color: #555555;
}

.skubox {
  width: 666px;
  padding-left: 14px;
  padding-right: 10px;
  padding-top: 16px;
  line-height: 60px;
  border: 2px solid #e3e3e3;
  border-top: none;
}

.checkedbox {
  display: inline-block;
  vertical-align: top;
}

.inlinerightbox {
  display: inline-block;
  vertical-align: top;
  width: 460px;
}

.marginbuttom10 {
  margin-bottom: 10px;
}

.margintop70 {
  margin-top: 70px;
  font-size: 24px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
}

.contentimg {
  margin-top: 80px;
  width: 100%;
}

.footbox {
  width: 750px;
  height: 160px;
  background: #ffffff;
  box-shadow: 0px -1px 7px 0px rgba(235, 235, 236, 0.42);
  position: fixed;
  left: 0px;
  bottom: 0px;
}

.zhanweifoot {
  width: 100%;
  height: 26px;
}

.zhaweifoot {
  width: 100%;
  height: 180px;
}

.footcontentbox {
  margin: 0 auto;
  width: 690px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.xinyuanbox {
  text-align: center;
  font-size: 20px;
  font-family: PingFang;
  font-weight: bold;
  color: #000000;
}

.xinyuanicon {
  margin: 0 auto;
  width: 40px;
  height: 40px;
}

.margintop10 {
  margin-top: 10px;
}

.jioncarbtn {
  width: 280px;
  height: 77px;
  background: #ffffff;
  border: 1px solid #000000;
  line-height: 78px;
  text-align: center;
  font-size: 24px;
  font-family: PingFang;
  font-weight: bold;
  color: #000000;
  display: inline-block;
  vertical-align: top;
}

.buybtn {
  width: 280px;
  height: 80px;
  background: #986665;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  line-height: 80px;

  font-size: 24px;
  font-family: PingFang;
  font-weight: bold;
  color: #ffffff;
}

.flexbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.numlable {
  font-size: 28px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
}

.pupbtn {
  margin: 0 auto;
  width: 690px;
  height: 80px;
  background: #986665;
  text-align: center;
  line-height: 80px;

  font-size: 26px;
  font-family: PingFang;
  font-weight: bold;
  color: #ffffff;
}

.pupmainbox {
  margin: 0 auto;
  width: 690px;
  padding-top: 100px;
  margin-bottom: 80px;
}

.recommendtitle {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 10px;
}

.imgbox2 {
  width: 300px;
}

/deep/ .el-select .el-input__inner:focus {
  border: 1px solid #eeeee2;
}

/deep/.el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #eeeee2;
}

/deep/.el-select-dropdown__item.selected {
  color: #606266;
}

// .el-select-dropdown__item .selected:hover{
//   color: #986665!important;
// }
.margintop12 {
  margin-top: 12px;
}

.zrl {
  display: none;
}

@media screen and (min-width: 1000px) {
  .zrl {
    display: block;
  }

  .commodityInfobox {
    display: none;
  }

  .footbox {
    display: none;
  }

  .pcfootbox {
    margin-left: 20px;
    width: 325px;
    border-top: 2px solid #000000;
    padding-top: 10px;
    // box-shadow: 0px -1px 7px 0px rgba(235, 235, 236, 0.42);

    .footcontentbox {
      width: 325px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
    }

    .xinyuanbox {
      text-align: center;
      font-size: 12px;
      font-family: PingFang;
      font-weight: bold;
      color: #000000;
    }

    .xinyuanicon {
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    .margintop10 {
      margin-top: 10px;
    }

    .jioncarbtn {
      box-sizing: border-box;
      width: 120px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #000000;
      line-height: 40px;
      text-align: center;
      font-size: 12px;
      font-family: PingFang;
      font-weight: bold;
      color: #000000;
      display: inline-block;
      vertical-align: top;
      cursor: pointer;
    }

    .buybtn {
      box-sizing: border-box;
      width: 120px;
      height: 40px;
      background: #986665;
      display: inline-block;
      vertical-align: top;
      text-align: center;
      line-height: 40px;

      font-size: 12px;
      font-family: PingFang;
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .zhaweifoot {
    display: none;
  }

  .pcpage {
    max-width: 1345px;
    margin: -25px auto;
    position: relative;
  }

  .pcproductdesc {
    display: inline-block;

    zoom: 1;
    vertical-align: top;
    width: calc(100% - 400px);
  }

  .pccommodityInfobox {
    width: 345px;
    margin-left: 45px;
    margin-top: 30px;
    vertical-align: top;
    display: inline-block;
    position: sticky;
    top: 0px;
  }

  .pcimgbox1 {
    margin-left: 20px;
    width: 325px;
  }

  .pccontentimg {
    width: 100%;
    margin-top: 30px;
    max-width: 900px;
  }

  .pccommoditytitlebox {
    margin-left: 20px;
    font-size: 16px;
    font-family: PingFang;
    font-weight: bold;
     //color: #666666;
     color: #555555;
  }

  .pccommoditynamebox {
    margin-top: 10px;
    font-size: 16px;
    font-family: PingFang;
    font-weight: 500;
    color: #333333;
  }

  .pccommoditytagbox {
    // margin-top: 20px;
  }

  .pccommoditytag {
    display: inline-block;
    vertical-align: top;
    margin: 0px 10px 10px 0px;
    width: fit-content;
    padding: 0 10px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    //color: #7c7d7d;
    border: 1px solid #bbbbbb;
    margin-left: 20px;
  }

  .pricebox {
    width: 307px;
    padding-left: 14px;
    line-height: 30px;
    height: 30px;
    margin-left: 20px;

    border: 2px solid #e3e3e3;
  }

  .pricelablebox {
    display: inline-block;
    vertical-align: top;
    width: 80px;
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    color: #333333;
  }

  .pricenumbox {
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    font-family: Heiti SC;
    font-weight: 500;
    // color: #000000;
    //color: #666666;
    color: #555555;
  }

  .skubox {
    margin-left: 20px;
    width: 297px;
    padding-left: 14px;
    padding-right: 10px;
    padding-top: 16px;
    line-height: 30px;
    border: 2px solid #e3e3e3;
    border-top: none;
  }

  .inlinerightbox {
    display: inline-block;
    vertical-align: top;
    width: 160px;
  }

  .marginbuttom10 {
    margin-bottom: 10px;
  }

  .margintop12 {
    margin-top: 12px;
  }

  .attrValuebox {
    margin-left: 20px;
    width: 325px;
    border-top: 2px solid #333;
    padding: 1px 0px;
    cursor: pointer;
  }

  .attrValuetitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    padding: 0px 14px;
  }

  .pad24 {
    padding: 12px;
  }

  .font24 {
    font-size: 12px;
    padding: 0 14px 10px;
  }

  .pczhanweione {
    width: 100%;
    height: 600px;
  }

  .pcrecommendtitle {
    max-width: 1345px;
    margin: 30px auto;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .pcimgbox2 {
    width: 300px;
  }

  .pc1345 {
    max-width: 1345px;
    margin: 30px auto;

    // display: flex;
    // justify-content: start;
    overflow: hidden;
    overflow-x: auto;
  }

  .el-carousel__item:nth-child(2n) {
    // background-color: #99a9bf;
    // background-color: #eeeee2;
    background-color: transparent;
  }

  .el-carousel__item:nth-child(2n + 1) {
    // background-color: #d3dce6;
    background-color: transparent;
    //  background-color: #eeeee2;
  }
  /deep/.el-carousel__mask {
    background-color: transparent;
  }
}
</style>